import React from 'react'
import { Wrapper } from 'components/Wrapper/Wrapper'
import {
  Catalog,
  Compliance,
  ContactFormPage,
  Contacts,
  Distribution,
  Home,
  NewsItem,
  NewsList,
  NotFound,
  PartnerFormPage,
  Production,
  AboutUs,
} from 'pages'
import { PartialRouteObject } from 'react-router'
import { ComplianceMemo } from './pages/ComplianceMemo'

export const Routes = (): PartialRouteObject[] => [
  {
    path: '/',
    element: React.createElement(Wrapper),
    children: [
      {
        path: '/',
        element: React.createElement(Home),
      },
      {
        path: '/distribution',
        element: React.createElement(Distribution),
      },
      {
        path: '/production',
        element: React.createElement(Production),
      },
      {
        path: '/contactForm',
        element: React.createElement(ContactFormPage),
      },
      {
        path: '/partnerForm',
        element: React.createElement(PartnerFormPage),
      },
      { path: 'catalog', element: React.createElement(Catalog) },
      {
        path: '/news',
        children: [
          {
            path: '/',
            element: React.createElement(NewsList),
          },
          { path: '/:id', element: React.createElement(NewsItem) },
          {
            path: '/draft/:id',
            element: React.createElement(NewsItem, { isDraft: true }),
          },
        ],
      },
      {
        path: '/contacts',
        element: React.createElement(Contacts),
      },
      {
        path: '/compliance',
        element: React.createElement(Compliance),
      },
      {
        path: '/compliance/memo',
        element: React.createElement(ComplianceMemo),
      },
      {
        path: '/about',
        element: React.createElement(AboutUs),
      },
      {
        path: '*',
        element: React.createElement(NotFound),
      },
    ],
  },
]
